import { Button, Col, Form, Input, Radio, Row, Space } from "antd";
import { useEffect } from "react";
import { SFTPChannel } from "../../model/client-model";

const SFTPConfiguration = ({proceedLabel = 'Proceed', show, client, channelField, onBack, onNext, onClose}: any) => {

    const [form] = Form.useForm();
    const credentialType = Form.useWatch([channelField, 'credentialType'], form);

    useEffect(() => {
        form.setFieldsValue(client);
        form.setFieldsValue({
            [channelField]: {
                type: 'SFTP', // Set only the 'type' field of the nested object
                credentialType: client?.[channelField]?.credentialType || 'PASSWORD',
            },
        });
    }, [client]);

    const requiredRule = (isRequired: boolean, message: string) => {
        return {
          required: isRequired,
          message: message,
        }
    }

    const onFinish = (channel: SFTPChannel) => {
        const data = {...client, ...channel};
        onNext(data);
    }

    return <Form 
        form={form}
        className="clients-page-form"
        onFinish={onFinish}
        style={{overflow: 'hidden', height: show ? 'auto' : '0rem'}}>

        <Form.Item 
            name={[channelField, 'type']}
            style={{display: 'none'}}>
            <Input/>
        </Form.Item>    
  
        <h2>Secure FTP Configuration</h2>
        
        <h3>Network Configuration</h3>
        <Row gutter={16}>
            <Col span={18}>
            <label>Host *</label>
            <Form.Item
                name={[channelField, 'host']}
                rules={[requiredRule(true, "Host is required.")]}
            >
                <Input />
            </Form.Item>
            </Col>
            <Col span={6}>
            <label>Port</label>
            <Form.Item  name={[channelField, 'port']}>
                <Input />
            </Form.Item>
            </Col>
        </Row>
        <Row gutter={16}>
            <Col span={12}>
            <label>Username</label>
            <Form.Item name={[channelField, 'username']}>
                <Input />
            </Form.Item>
            </Col>
            <Col span={12}>
            <label>Password</label>
            <Form.Item name={[channelField, 'password']}>
                <Input.Password />
            </Form.Item>
            </Col>
        </Row>
        <label>Credential Type</label>
        <Form.Item name={[channelField, 'credentialType']}>
            <Radio.Group>
                <Radio value="PASSWORD">Password</Radio>
                <Radio value="PEM_KEY">PEM Key</Radio>
            </Radio.Group>
        </Form.Item>
        {credentialType === 'PEM_KEY' &&
            <>
                <label>PEM Key *</label>
                <Form.Item
                    name={[channelField, 'pemKey']}
                    rules={[requiredRule(true, "PEM Key is required.")]}
                >
                    <Input.TextArea rows={9} />
                </Form.Item>
            </>
        }
        <h3>File and Directory Management</h3>
        <label>Target Directory</label>
        <Form.Item name={[channelField, 'directory']}>
            <Input />
        </Form.Item>
        <label>File Name *</label>
        <Form.Item
            name={[channelField, 'filename']}
            rules={[requiredRule(true, "Filename is required.")]}
        >
            <Input />
        </Form.Item>

        <Space direction="horizontal" align="end" style={{marginTop: '2rem', width: '100%', justifyContent: 'flex-end'}}>
            <Button type="default" key="cancel" onClick={onClose}>Cancel</Button>
            <Button type="primary" onClick={onBack}>Back</Button>
            <Button type="primary" htmlType="submit">{proceedLabel}</Button>
        </Space>
    </Form>
  }

  export default SFTPConfiguration;